/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Done_CancelledInputs */

const en_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan has been cancelled.`)
};

const de_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Abo wurde gekuendigt.`)
};

const fr_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton abonnement a ete annule.`)
};

const es_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan ha sido cancelado.`)
};

const it_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo piano e stato annullato.`)
};

const nl_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je plan is geannuleerd.`)
};

const pl_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoj plan zostal anulowany.`)
};

const fi_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilauksesi on peruutettu.`)
};

const da_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din plan er blevet annulleret.`)
};

const sv_cancel_done_cancelled = /** @type {(inputs: Cancel_Done_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din plan har avbrutits.`)
};

/**
* | output |
* | --- |
* | "Your plan has been cancelled." |
*
* @param {Cancel_Done_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_done_cancelled = /** @type {((inputs?: Cancel_Done_CancelledInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Done_CancelledInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_done_cancelled(inputs)
	if (locale === "fr") return fr_cancel_done_cancelled(inputs)
	if (locale === "es") return es_cancel_done_cancelled(inputs)
	if (locale === "it") return it_cancel_done_cancelled(inputs)
	if (locale === "nl") return nl_cancel_done_cancelled(inputs)
	if (locale === "pl") return pl_cancel_done_cancelled(inputs)
	if (locale === "fi") return fi_cancel_done_cancelled(inputs)
	if (locale === "da") return da_cancel_done_cancelled(inputs)
	if (locale === "sv") return sv_cancel_done_cancelled(inputs)
	return en_cancel_done_cancelled(inputs)
});